import React from 'react';
import {FormattedMessage} from 'react-intl';

import Badge from './badge';

type Props = {
    className?: string;
    show?: boolean;
}

const BotBadge: React.FC<Props> = (props: Props) => (
    <Badge
        className={'BotBadge ' + props.className}
        show={props.show}
    >
        <FormattedMessage
            id='post_info.bot'
            defaultMessage='Bot'
        />
    </Badge>
);

BotBadge.defaultProps = {
    show: true,
    className: '',
};

export default BotBadge;
